<template>
    <div>
        <div class="row">

            <div class="col-sm-12 company-form-box-title mb-3">
                Leave
            </div>
            <div class="col-sm-6 mb-3">
                <div class="custom-search">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>


                </div>
            </div>

            <div class=" col-sm-6 text-right  action mb-3">
                <b-form-select id="year" name="year" v-model="year" :options="years"
                    @change="getLeaves"></b-form-select>
                <b-button :href="$api_url + '/employee/leave/import/template?f=1&year=' + year"><b-icon
                        icon="code-slash"></b-icon> Template </b-button>
                <b-button @click="$bvModal.show('bv-leave-history')"><b-icon icon="box-arrow-up" class=""
                        scale="1"></b-icon> Import </b-button>
            </div>
        </div>

        <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0 mb-3">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table"
                        style="table-layout:fixed;">
                        <thead class="" style="">
                            <tr class="table-head">
                                <!-- alpha fix- moved the span isndie label  and added mb-0 -->
                                <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
                                    :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                    style="cursor:pointer;"> <label
                                        class="custom-label mb-0">
                                    <span>{{ column.label }}</span>
                                </label>
                            </td>
                                <!-- <td class="text-right" v-if="ce">Action</td> -->
                                 <!-- alpha fix- added style here  -->
                                  <!-- alpha fix- added mb-0  -->
                                <td class="text-right" v-if="ce">
                                    <label class="custom-label mb-0">
                                        <span style="padding-right: 0 !important;">Action</span>
                                    </label>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(leave, n) in paginatedData">
                                <tr class="table-row hover-bg">
                                    <td class=" ">
                                        <div class="img-holder">
                                            <img v-if="leave.employee_pic != ''"
                                                v-bind:src="'/avatar/' + leave.company_id + '/' + leave.employee_pic"
                                                class="img-fluid img-thumbnail employee-avatar mr-2" />
                                            <img v-else v-bind:src="'/avatar/demo.jpg'"
                                                class="img-fluid img-thumbnail employee-avatar mx-2" />
                                        </div>
                                        <div class="name-holder">
                                            {{ leave.employee_name }}<br />
                                            <span class="txt-alt">{{ leave.employee_code }}</span>
                                        </div>

                                    </td>
                                    <td class="">
                                        {{ leave.jobposition }}
                                    </td>
                                    <td class="">
                                        {{ leave.department }}
                                    </td>
                                    <td class="">
                                        {{ leave.leave_type }}
                                    </td>
                                    <td class="">
                                        {{ leave.from }}
                                    </td>
                                    <td class="">
                                        {{ leave.to }}
                                    </td>
                                    <td class="">
                                        {{ leave.number_of_days }}
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span>
                                    </td>
                                    <td class="leave-reason-wrapper">
                                        {{ leave.reason }}
                                    </td>

                                    <td class="">
                                        <span class="leave-status" v-if="leave.status == 'Approved'"><i
                                                class="far fa-dot-circle mr-1 text-success"></i>{{ leave.status }}</span>
                                        <span class="leave-status" v-else-if="leave.status == 'Applied'"><i
                                                class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
                                        <span class="leave-status" v-else-if="leave.status == 'Declined'"><i
                                                class="far fa-dot-circle mr-1 text-danger"></i>{{ leave.status }}</span>
                                    </td>

                                    <td class="">
                                        {{ leave.updated_by }}
                                    </td>

                                    <td class="position-relative text-right" v-if="ce">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <!-- Abdullah26 added px-1 and text-left  -->
                                        <div class="dropdown-menu action-dropdown-menu w-200 px-1"
                                            aria-labelledby="actionDropdown">
                                            <b-button-group class="mr-0">

                                                <b-button class="rounded delete-btn text-left"
                                                    title="Delete Work Location"
                                                    @click="deleteLeave(leave.employee_id, leave.leave_type_id, leave.flg_status, leave.from, leave.to)">
                                                    <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                </b-button>

                                            </b-button-group>
                                        </div>

                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>


                    <div v-if="paginatedData.length == 0" class="mb-3 list-no-data">
                        No records found.
                    </div>
                    <div v-else class="mt-3"><b-pagination-nav v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number><template #prev-text><span>Previous</span></template><template
                                #next-text><span>Next</span></template></b-pagination-nav></div>
                </b-overlay>
            </div>
        </div>

        <div class="row">

            <div class="col-sm-12 company-form-box-title mb-3">
                Carry Data
            </div>
        </div>
        <carrying-data :pageurl="$api_url"></carrying-data>

        <b-modal id="bv-leave-history" size="lg" hide-footer title="Upload consumed leaves on current leave year here">
            <!-- alpha fix- maked the text inside a div, before it was inside a h4 tag also added mb-2 class to the div to give some margin bottom -->
            <div class="mb-2">Please use the template</div>
            <!-- alpha fix- addded class mb-5 to the b-form-file to give some margin bottom so that the file input is not too close to the modal footer -->
            <b-form-file class="mb-5" id="datafile" name="datafile" @change="uploadLeaveFile" accept=".xlsx,.xls"></b-form-file>
        </b-modal>

        <!-- <b-tabs pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
            <b-tab >

                <div class="">



                </div>
            </b-tab>
            <b-tab lazy>
                <template active v-slot:title>Days Carried Forward</template>
                <div class="">
                    <carrying-data ></carrying-data>
                </div>
            </b-tab>
        </b-tabs>
        <b-modal id="bv-leave-history" size="lg" hide-footer title="Upload consumed leaves on current leave year here">
            <h4>Please use the template</h4>
            <b-form-file id="datafile" name="datafile" @change="uploadLeaveFile"  accept=".xlsx,.xls"></b-form-file>

        </b-modal> -->
    </div>
</template>
<script>
import moment from 'moment'
export default {

    mounted() {
        if (this.check_ce == 1) {
            if (this.ce_flg == 1)
                this.ce = true;
            else
                this.ce = false;

        }
    },
    props: ['flg'],
    components: {},
    data() {
        const now = new Date()
        let sortOrders = {};
        let columns = [
            { label: 'Employee', name: 'employee_name' },
            { label: 'Job Position', name: 'employee_code' },
            { label: 'Department', name: 'department' },
            { label: 'Leave Type', name: 'leave_type' },
            { label: 'From', name: 'from' },
            { label: 'To', name: 'to' },
            { label: 'No. of Days', name: 'number_of_days' },
            { label: 'Reason', name: 'reason' },
            { label: 'Status', name: 'status' },
            { label: 'Updated By', name: 'updated_by' },
        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });


        return {

            search_by_id: { department_id: 0, leave_type_id: 0, flg_status: 0 },
            year: now.getFullYear(),
            years: [{ text: now.getFullYear() - 1, value: now.getFullYear() - 1 }, { text: now.getFullYear(), value: now.getFullYear() }],

            leavetypes: [],
            flg_status: [
                { text: 'Applied', value: '0' },
                { text: 'Approved', value: '1' },
                { text: 'Declined', value: '2' },
            ],

            /** Sohel Code Starts Here */
            columns: columns,
            sortKey: 'employee_name',
            sortOrders: sortOrders,
            /** Sohel Code Ends Here */

            leaves: [],

            showoverlay: false,

            search: '',
            length: 20,
            pagination: { currentPage: 1, pages: 1 },

            ce: true,
            empfile: null,
        }
    },
    methods: {

        uploadLeaveFile: function (event) {
            if (!this.checkNet()) return false;
            this.empfile = event.target.files[0];

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            const data = new FormData();
            data.append('empfile', this.empfile);

            axios.post(this.$api_url + '/employee/leave/import/import?past=true', data, config).
                then(function (response) {
                    this.$bvToast.toast('Successfully Imported', {
                        title: `Success`,
                        variant: 'info',
                        solid: true
                    });




                    this.$bvModal.hide('bv-leave-history');
                    this.getLeaves();

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
            this.showoverlay = false;
        },

        getLeaves: function () {
            this.showoverlay_list = true;
            if (!this.checkNet()) return false;

            let currentObj = this;
            axios.get(this.$api_url + '/employees/leaves/fiscalyear?year=' + this.year, {
                params: {

                }
            }).then(function (response) {
                this.showoverlay_list = false;
                this.leaves = response.data.leaves;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },


        deleteLeave: function (employee_id, leave_type_id, flg_status, from, to) {
            let formData = new FormData();
            formData.append('employee_id', employee_id);
            formData.append('leave_type_id', leave_type_id);
            formData.append('from', from);
            formData.append('to', to);
            formData.append('flg_status', flg_status);



            axios.post(this.$api_url + '/leave/delete/range', formData)
                .then(function (response) {
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });


                    this.getLeaves();
                    //this.getApprovePendingLeavesToday();

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },





        getLeaveTypes: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/leave/types', {

            }).then(function (response) {

                this.leavetypes = response.data;
            }.bind(this));
        },


    },
    created: function () {

        this.getLeaveTypes();

        this.getLeaves();

    },
    computed:
    {
        filteredData() {
            let filtered_list = this.leaves;
            if (this.search) {

                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },

        fetchStartWeekday() {
            return this.week_start_day;
        },
    }
}
</script>
<style scoped>
.action .custom-select {
    width: auto !important;
}
</style>
